export class ManifestoStatusDTO {

    id: number;
    valor: string;

    constructor() {

        this.id =  0;
        this.valor = 'Pendente';

    }

}